import mod from "-!./loggingForm.js?vue&type=script&lang=js&external"; export default mod; export * from "-!./loggingForm.js?vue&type=script&lang=js&external"